import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_button extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_button">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Button</h2>
              <p>
                Record button overrides the interfaces autosave setting and when
                clicked stamp a date field with a current DateTime. This
                DateTime stamp can have a change event assigned to it through
                the workflow component of the application. This will give you
                the ability to run code at the server level-triggered from a
                user's click. Button also supports an on-click eval method for
                javascript to run in the interface. For more information about
                the NL Library, look at the workflow section of this
                documentation.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_button"}
                name={"button"}
                dataNameDefault={
                  '"date_click_button" or "object_my_obj.date_click_button"'
                }
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                displayName={true}
                properties={[
                  {
                    property: "on_click_eval",
                    description:
                      "Allows you to insert javascript code at the client level when the button is clicked.",
                    defaults:
                      "\"console.log('NL and event in console.', { NL: NL, event: event })\"",
                  },
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Button Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Button</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_button"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"date_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Press Me"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#01579B"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"right"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonY">300</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">
                    "console.log('Button was clicked.')"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_button;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_button.js